import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { connect } from 'react-redux';
import { getColors, getSizes, getProductTypes } from '../../../../../Redux/Actions/CommonActions';
import './../ManageEvents/Events.scss';
import ReactFileReader from 'react-file-reader';
import { Switch } from '@progress/kendo-react-inputs';
import '@progress/kendo-react-common'
import '@progress/kendo-date-math'
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import { Alert } from 'reactstrap';

class ArchiveForm extends Component {
	months = [
		{ name: "January", id: 1 },
		{ name: "February", id: 2 },
		{ name: "March", id: 3 },
		{ name: "April", id: 4 },
		{ name: "May", id: 5 },
		{ name: "June", id: 6 },
		{ name: "July", id: 7 },
		{ name: "August", id: 8 },
		{ name: "September", id: 9 },
		{ name: "October", id: 10 },
		{ name: "November", id: 11 },
		{ name: "December", id: 12 },
	];

	years = [];
	showErrorMessage = false;

	getYears = () => {
		var years = [];
		for (var i = (new Date()).getFullYear() + 10; i >= 1900 ; i--) {
			years.push({ id: i, name: i + '' });
		}

		return years;
	}
	constructor(props) {
		super(props);

		this.years = this.getYears();
		this.state = {
			archiveInEdit: this.props.dataItem || null,
			originalTitle: this.props.dataItem ? this.props.dataItem.Title : '',
			month: this.props.dataItem ? this.months[this.props.dataItem.Month - 1] : null,
			year: this.props.dataItem.ArchiveId ? { id: Number(this.props.dataItem.Year), name: this.props.dataItem.Year + '' } : null,
			features: this.props.dataItem ? this.props.dataItem.Features : '',
			imageUrl: this.props.dataItem ? this.props.dataItem.ThumbnailUrl : '',
			magazineUrl: this.props.dataItem ? this.props.dataItem.MagazineUrl : '',
			magazineUrlMessage: '',
			isMagazineUrlChanged: false,
			isImageChanged: false,
			//isPdfChanged: false,
			title: this.props.dataItem ? this.props.dataItem.Title:'',
			titleMessage: '',
			//pdfTitle: this.props.dataItem ? this.props.dataItem.PDFTitle : '',
			//uploadTitle: this.props.dataItem ? this.props.dataItem.PDFUrl ? this.props.dataItem.PDFUrl : 'Digital Issue PDF' : 'Digital Issue PDF',
			coverMessage: '',
			//pdfMessage: '',
			alertVisible: false,
			alertColor: "danger",
			alertMessage: ""
		};
	};

	componentDidMount() {

	}

	showAlert = (color, msg) => {

		this.setState({
			alertVisible: true,
			alertColor: color,
			alertMessage: msg
		});

		setTimeout(() => {
			this.setState({
				alertVisible: false,
				alertMessage: ''
			});
		}, 5000);
	}

	handleSubmit = (event) => {
		event.preventDefault();
		let valid = true;

		this.refs.submitBtn.disabled = true;

		let model = {
				month: this.state.month.id,
				year: this.state.year.id,
				features: this.state.features,
				title: this.state.title,
				archiveId: this.state.archiveInEdit ? this.state.archiveInEdit.ArchiveId : 0,
				thumbnailUrl: this.state.imageUrl,
				image: this.state.image,
				//pdf: this.state.pdf,
				isImageChanged: this.state.isImageChanged,
				//isPdfChanged: this.state.isPdfChanged,
				isMagazineUrlChanged: this.state.isMagazineUrlChanged,
				//pdfTitle: this.state.pdfTitle,
				magazineUrl: this.state.magazineUrl
			}

		// Check if Edited archive and the image but no image found OR New achive but no image found
		if (((model.archiveId && model.isImageChanged) || !model.archiveId) && model.image == undefined) {
			valid = false;
			this.setState({
				coverMessage: 'Image required'
			})
		}

		// Check if Edited archive and the PDF but no PDF found OR New achive but no PDF found
		//if (((model.archiveId && model.isPdfChanged) || !model.archiveId) && model.pdf == undefined) {
		//	valid = false;
		//	this.setState({
		//		pdfMessage: 'PDF required'
		//	})
		//}

		// Check if Edited archive and the MagazineUrl but no MagazineUrl found OR New achive but no MagazineUrl found
		if (((model.archiveId && model.isMagazineUrlChanged) || !model.archiveId) && !model.magazineUrl) {
			valid = false;
			this.setState({
				magazineUrlMessage: 'Magazine URL required'
			})
		}

		if (!valid) {

			this.refs.submitBtn.disabled = false;
			return;
		}

		this.showAlert('info', 'Saving...');

		axios.post(`${ROOT_API_URL}/ManageArchive/IsDuplicateTitle`, model, { headers: auth.authHeader() })
		.then((response) => {

			if (response.data.message != "" && this.state.originalTitle != this.state.title) {
				this.setState({
					titleMessage: response.data.message
				}, () => {
					this.refs.submitBtn.disabled = false;
				});

			} else if (valid) {
				this.refs.submitBtn.disabled = false;

				this.props.save(model);
			}
		})
		.catch((error) => {
			var err = error && error.data ? error.data.message : 'Unable to save/update the Archive.';

			this.showAlert('danger', err);
			this.refs.submitBtn.disabled = false;

		});
	}

	handleImageFiles = (event) => {

		this.setState({
			imageUrl: event.base64,
			isImageChanged: true,
			coverMessage:'',
			image: {
				name: event.fileList[0].name,
				source: event.base64,
				extension: event.fileList[0].type
			}
		});
	}

	//handlePdfFiles = (event) => {

	//	if(event.fileList[0].type === "application/pdf"){
	//		this.setState({
	//			showErrorMessage:false
	//		})
	//		let Pdf = event ? {
	//			name: event.fileList[0].name,
	//			source: event.base64,
	//			extension: event.fileList[0].type
	//		} : null;

	//		this.setState({
	//			pdf: Pdf,
	//			pdfTitle: event.fileList[0].name,
	//			isPdfChanged: true,
	//			pdfMessage: ''
	//		});
	//	}
	//	else{
	//		this.setState({
	//			showErrorMessage:true
	//		})
	//	}
	//}

	handleMonthChange = (event) => {
		this.setState({
			month: event.target.value
		});
	}

	handleYearChange = (event) => {
		this.setState({
			year: event.target.value
		});
	}

	onFeaturesChange = (event) => {
		this.setState({
			features: event.target.value
		})
	}

	onTitleChange = (event) => {
		this.setState({
			title: event.target.value,
			titleMessage:''
		})
	}

	onMagazineUrlChange = (event) => {
		this.setState({
			magazineUrl: event.target.value || '',
			isMagazineUrlChanged: true,
			magazineUrlMessage: event.target.value ? '' : 'Invalid URL, make sure the url contains http or https'
		})
	}

	render() {
		return (
			<div className="archive-form">
				<Dialog onClose={this.props.cancel}>
					{this.state.archiveInEdit.ArchiveId ?
						<h2 className="adjust-dist-title">Edit Archive Item</h2>:
						<h2 className="adjust-dist-title">Add New Archive Item</h2> }
					<form className="" onSubmit={this.handleSubmit}>
						<Alert
							color={this.state.alertColor}
							isOpen={this.state.alertVisible}
							toggle={() => {
								this.setState({ alertVisible: false, alertMessage: "" })
							}}
						>
							{this.state.alertMessage}
						</Alert>
						<div className="row">
							<div className="form-group col-md-6">
								<label htmlFor="year">Year</label>
								<DropDownList
									required={true}
									data={this.years}
									onChange={this.handleYearChange}
									value={this.state.year}
									textField="name"
									dataItemKey="id"
									name="year"
									id="year"
								/>
							</div>
							<div className="form-group col-md-6">
								<label htmlFor="month">Month</label>
								<DropDownList
									required={true}
									data={this.months}
									onChange={this.handleMonthChange}
									value={this.state.month}
									textField="name"
									dataItemKey="id"
									name="month"
									id="month"
								/>
							</div>
						</div>
						<div className="row">
							<div className="form-group col-md-12">
								<label htmlFor="title">Title</label>
								<Input
									required={true}
									type="text"
									name="title"
									id="title"
									value={this.state.title}
									onChange={this.onTitleChange}
								/>
								<p className="error-message" style={{ color: "#d0021b" }}>{this.state.titleMessage}</p>
							</div>						
						</div>
						<div className="row">
							<div className="form-group col-md-12">
								{/*<label htmlFor="features">Features</label>
								<textarea
									required={true}
									type="text"
									name="features"
									id="features"
									className="k-textarea"
									value={this.state.features}
									onChange={this.onFeaturesChange}
								></textarea>*/}
								<label htmlFor="magazineUrl">Magazine URL</label>
								<Input
									required={true}
									type="url"
									name="magazineUrl"
									id="magazineUrl"
									value={this.state.magazineUrl}
									onChange={this.onMagazineUrlChange}
								/>
								<p className="error-message" style={{ color: "#d0021b" }}>{this.state.magazineUrlMessage}</p>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6">
								<label htmlFor="features">Cover Image</label>
								<ReactFileReader required={true} fileTypes={[".jpg", ".jpeg", ".png"]} base64={true} multipleFiles={false} handleFiles={this.handleImageFiles} >
									<div className='btnPrimary'>
										<i className="fas fa-file-upload"></i>
										<span>Upload File</span>
									</div>
									<p className="error-message">{this.state.coverMessage}</p>
								</ReactFileReader>
								
							<div>						
									{this.state.imageUrl ?
										<div>
											<br></br>
											<img alt="" src={this.state.imageUrl} />
										</div>										
									:""}
								</div>
							</div>							
							{/*<div className="col-md-6">{ this.state.showErrorMessage == true ?
									<label className="errortextColor" >Error: File Must Be PDF</label> : 
									<label htmlFor="features">{this.state.pdfTitle ? this.state.pdfTitle : this.state.uploadTitle}</label>
								}								
								<ReactFileReader required={true} fileTypes={[".pdf"]} base64={true} multipleFiles={false} handleFiles={this.handlePdfFiles} >
									<div className='btnPrimary'>
										<i className="fas fa-file-upload"></i>
										<span>Upload File</span>
									</div>
									<p className="error-message">{this.state.pdfMessage}</p>
								</ReactFileReader>
							</div>*/}
						</div>
						<DialogActionsBar>
							<div className="adjust-btns">
								<div className="form-group">
									<button className="admin-k-button" onClick={this.props.cancel}>
										<i className="fas fa-times"></i>
										<span> CANCEL</span>
									</button>
									{this.state.archiveInEdit.ArchiveId ? (
										<button type="submit" ref="submitBtn" className="admin-k-button">
											<i className="fas fa-edit"></i>
											<span> UPDATE</span>
										</button>
									) : (

										<button type="submit" ref="submitBtn" className="admin-k-button">
											<i className="fas fa-save"></i>
											<span> SAVE</span>
										</button>
										)}
								</div>
							</div>
						</DialogActionsBar>
					</form>
				</Dialog>
			</div>
		);
	}
}

export default ArchiveForm;
